module.exports = __webpack_public_path__ + "img/29.cdc59300.jpg";